<template>
    <div>
        <el-dialog
            :title="dialogFormTitle"
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="30%"
            :center="true"
            top="20vh"
            :close-on-click-modal="false"
            :before-close="() => closeProductDialog('ProductEditForm')"
            v-loading.fullscreen.lock="login_loading"
        >
            <div>
                <el-form
                    :model="Product"
                    :rules="rules"
                    ref="ProductEditForm"
                    label-width="100px"
                    size="small"
                >
                    <div v-if="show_type">
                        <el-form-item label="产品名称" prop="name">
                            <el-input v-model="Product.name" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="所属客户" prop="with_client_id">
                            <el-select
                                v-model="Product.with_client_id"
                                filterable
                                placeholder="请选择客户"
                                class="clientc"
                            >
                                <el-option
                                    v-for="item in AllClient"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div v-else>
                        <el-descriptions
                            class="margin-top"
                            :column="1"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>产品名称</span>
                                </template>
                                <span>{{Product.name}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>所属客户</span>
                                </template>
                                <span>{{Product.with_client_name}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>可用状态</span>
                                </template>
                                <el-tag v-if="Product.status === 1" type="success" effect="plain">正常</el-tag>
                                <el-tag v-else-if="Product.status === 0" type="danger" effect="plain">禁用</el-tag>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <div v-if="show_type===0">
                    <el-button
                        v-if="$_has(status_auth) && (Product.status === 0)"
                        type="success"
                        plain
                        @click="edit_status"
                        >启用</el-button
                    >
                    <el-button
                        v-if="$_has(status_auth) && (Product.status === 1)"
                        type="danger"
                        plain
                        @click="edit_status"
                        >禁用</el-button
                    >
                    <el-button
                        v-if="$_has(edit_auth)"
                        type="primary"
                        plain
                        @click="$emit('show_edit')"
                        >修改</el-button
                    >
                    <el-button
                        v-if="$_has(del_auth)"
                        type="danger"
                        plain
                        @click="ProductDel('ProductEditForm')"
                        >删除</el-button
                    >
                    <el-button
                        plain
                        @click="closeProductDialog('ProductEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else-if="show_type===1">
                    <el-button
                        type="success"
                        plain
                        @click="submitInsert('ProductEditForm')"
                        >确定</el-button
                    >
                    <el-button
                        type="warning"
                        plain
                        @click="resetForm('ProductEditForm')"
                        >重置</el-button
                    >
                    <el-button
                        plain
                        @click="closeProductDialog('ProductEditForm')"
                        >关闭</el-button
                    >
                </div>
                <div v-else>
                    <el-button
                        type="success"
                        plain
                        @click="submitEdit('ProductEditForm')"
                        >确定修改</el-button
                    >
                    <el-button
                        plain
                        @click="closeProductDialog('ProductEditForm')"
                        >取消操作</el-button
                    >
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { product_add_request,product_del_request,product_edit_request,product_status_request } from '@/network/WareHouse/product.js'

export default {
    name: 'ProductEditComponent',
    data() {
        return {
            login_loading: false,
            Product: {
                name: '',
                with_client_id: '',
                status: ''
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入产品名称',
                        trigger: 'blur',
                    }
                ],
                with_client_id: [
                    {
                        required: true,
                        message: '请选择所属客户',
                        trigger: 'blur',
                    },
                ],
            },
        }
    },
    computed: {
        dialogFormTitle() {
            if(this.show_type === 0) {
                return '产品详情'
            } else if (this.show_type === 1) {
                return '添加产品'
            } else {
                return '修改产品'
            }
        },
    },
    methods: {
        closeProductDialog(formName) {
            this.$refs[formName].resetFields()
            this.$emit('exitProductDialog')
        },
        submitInsert(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.ProductInsert(formName)
            })
        },
        ProductInsert(formName) {
            this.login_loading = true
            product_add_request(this.Product)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.$emit('exitProductDialog')
                        this.$emit('search')
                        this.$emit('details_row',s.result.id*1)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },
        submitEdit(formName) {
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    return
                }
                this.ProductEdit(formName)
            })
        },
        ProductEdit(formName) {
            this.login_loading = true
            this.Product.id = this.id
            product_edit_request(this.Product)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.$emit('exitProductDialog')
                        this.$emit('search')
                        this.$emit('details_row',this.Product.id)
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        ProductDel(formName) {
            this.$confirm(
                '是否确定删除？（一经删除，将无法再进行恢复，请谨慎操作！）',
                '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                }
            )
                .then(() => {
                    product_del_request(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                this.$message.success('删除成功!')
                                this.$emit('search')
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() => this.closeProductDialog(formName))
                })
                .catch((err) => {})
        },
        edit_status() {
            product_status_request(this.id)
                        .then((s) => {
                            if (s.status === 0) {
                                if(this.Product.status === 1) {
                                    this.$message.error('已禁用!')
                                } else {
                                    this.$message.success('已启用!')
                                }
                                
                            } else {
                                this.$message.error(s.msg)
                            }
                        })
                        .catch((err) => {
                            this.$message.error(err)
                        })
                        .finally(() =>  {
                            this.closeProductDialog('ProductEditForm')
                            this.$emit('exitProductDialog')
                            this.$emit('search')
                            this.$emit('details_row',this.Product.id)
                        })
        }
    },
    filters: {},
    props: {
        dialogFormVisible: Boolean,
        id: {
            type: Number,
            default() {
                return 0
            },
        },
        product_details_data: {
            type: Object,
            default() {
                return {}
            },
        },
        show_type: {
            type:Number,
            default() {
                return 0
            },
        },
        AllClient: {
            type:Array,
            default() {
                return []
            },
        },
        edit_auth: String,
        del_auth: String,
        status_auth: String
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {
        product_details_data(newVal) {
            this.Product = newVal
        },
    },
}
</script>

<style lang='less'>
.clientc {
    width: 100%;
}
</style>